import CustomBackdrop from 'components/Backdrop';
import CustomHelmet from 'components/Helmet';
import KeepaEnLogo from 'assets/img/LogoEnColor4.png';
import React, { useState, Suspense } from 'react';
import RouterApp from 'router/Router';
import SplashScreen from 'components/SplashScreen';
import 'utils/redirectCapture'; // Import redirect capture utility
import qs from 'query-string';
import useManifest from 'Hook/General/useManifest';
import useScrollToTop from 'Hook/useToTop';
import useWhiteLabelProject from 'Hook/useEntkhabino';
import useWindowFocus from 'Hook/useWindowClick';
import withOfflineMode from 'HOC/withOfflineMode';
import withPWA from 'HOC/withInstallPWA';
import { Box, useMediaQuery } from '@material-ui/core';
import { booleanParser } from 'services/booleanParser';
import usePwaSplash from 'Hook/General/usePwaSplash';
import { Toaster } from 'react-hot-toast';
import Android from 'components/PWA/Android';
import { PLATFORM } from 'services/PWA';

const ImageKit = React.lazy(() => import('components/Image'));

function App() {
	const [isLoading, setIsLoading] = useState(true);
	const { isWhiteLabelDomain, isFara } = useWhiteLabelProject();
	const matches = useMediaQuery('(min-width:480px)');
	const isLogoView = useMediaQuery('(min-width:1000px)');
	const parseLocation = qs.parse(location.search);

	// Initialize hooks
	useManifest();
	useScrollToTop();
	useWindowFocus(setIsLoading);
	usePwaSplash();

	// Handle wallet display settings
	React.useEffect(() => {
		if (booleanParser(parseLocation?.show_wallets)) {
			sessionStorage.setItem('show_wallets', JSON.stringify(parseLocation?.show_wallets?.split(',')));
		}
	}, [parseLocation?.show_wallets]);

	const mobileViewProps = matches ? { id: 'mobile-view' } : {};

	const renderLogo = () => (
		<Box position={'fixed'} right="10%" bottom="5%">
			<Suspense fallback={<></>}>
				<ImageKit src={KeepaEnLogo} alt="logo" width="149px" height="60px" />
			</Suspense>
		</Box>
	);

	const renderContent = () => (
		<Box>
			<div {...mobileViewProps}>
				{PLATFORM === 'android' && isFara && <Android />}
				<RouterApp />
				<CustomBackdrop />
			</div>
			{!isWhiteLabelDomain && matches && isLogoView && renderLogo()}
		</Box>
	);

	return (
		<>
			<Toaster />
			<CustomHelmet />
			{isLoading ? (
				<div {...mobileViewProps}>
					<SplashScreen />
				</div>
			) : (
				renderContent()
			)}
		</>
	);
}

const PWA = withPWA(App);
const Version = PWA;

export default withOfflineMode(Version);
